export const badRequest = (): Error => new Error('Your request cannot be processed at this time.');

export const serverError = (): Error => new Error('An unexpected error has occurred.');
